import { Bar, BarChart, ResponsiveContainer, XAxis, YAxis } from "recharts";

import { GraphConfig } from "@intelligems/ig-types/schemas/analytics/custom-graphs";
import { getRandomIntInclusive } from "@intelligems/ig-utils/common";
import { useTheme } from "@mui/material";
import Grid from "@mui/material/Grid";

interface IgBarChartSkeletonProps {
  config: GraphConfig;
  useLargeDataset?: boolean;
}

export const IgBarChartSkeleton = ({
  config,
  useLargeDataset,
}: IgBarChartSkeletonProps) => {
  const theme = useTheme();
  const fakeBarData = Array(useLargeDataset ? 12 : 2)
    .fill("")
    .map(() => ({
      name: "fake",
      value: getRandomIntInclusive(1, 5),
      value2: getRandomIntInclusive(1, 5),
    }));
  return (
    <Grid>
      <ResponsiveContainer
        height={config.isImpactGraph ? 150 : 300}
        width="100%"
      >
        <BarChart
          margin={{ top: 15, bottom: -10, right: -5, left: -20 }}
          data={fakeBarData}
          maxBarSize={60}
        >
          <XAxis
            interval={0}
            tick={false}
            axisLine={{ stroke: theme.igBorders.core.disabled }}
            tickLine={false}
            dataKey={"name"}
          />
          <YAxis
            tickFormatter={() => "###"}
            tick={false}
            style={{ fontFamily: theme.typography.fontFamily, fontSize: 12 }}
            axisLine={
              config.isImpactGraph
                ? false
                : { stroke: theme.igBorders.core.disabled }
            }
            tickLine={false}
          />
          <Bar
            fill={theme.igPrimitives.gray["A100"]}
            className="infinite-pulsing"
            dataKey="value"
            name={config.title[0]}
            radius={[3, 3, 0, 0]}
          />
        </BarChart>
      </ResponsiveContainer>
    </Grid>
  );
};
